export default __webpack_public_path__ + "static/media/4_Lista.e496eb80.webp";